import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting to enable change on OWF application email and notification messages.
 * https://www.notion.so/OWF-soft-credit-check-7a1e0624758246f5a87e77ef8b7a2318
 */
export const OWF_APPLICATION_FUNNEL_OPTIMIZATIONS_XP_V2_250312 =
  'OWF_APPLICATION_FUNNEL_OPTIMIZATIONS_XP_V2_250312' as SettingConst<
    'OWF_APPLICATION_FUNNEL_OPTIMIZATIONS_XP_V2_250312',
    boolean,
    'RETAILER' | 'VISITOR_WEB' | 'HOTJAR_RETAILER' | 'HOTJAR_VISITOR_WEB'
  >;
